import React from 'react';

import type { ImageFetchProps, StaticBanner as StaticBannerType } from '../../model/types';
import BannerImage from '../BannerImage/BannerImage';

import styles from './StaticBanner.scss';

const StaticBanner: React.FC<StaticBannerType & ImageFetchProps> = ({ link, image, priority }) => (
  <a className={styles.container} href={link}>
    <BannerImage image={image} priority={priority} isCenterImage />
  </a>
);

export default StaticBanner;
